var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CompoundToolVariable_1;
import { log } from '@symon-ai/wisepipe-log';
import { JSON, JsonDiscriminatorProperty, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ToolParameterHelper } from './toolParameterHelper';
import { ToolVariable, ToolVariableType } from './toolVariable';
import { compoundToolVariableSchemaValidation } from '../validations.generated';
export const compoundToolVariableSchema = {
    $id: 'urn:wisepipe-base-pipe:CompoundToolVariable',
    type: 'object',
    properties: {
        value: { type: 'string' }
    },
    required: ['value']
};
let CompoundToolVariable = CompoundToolVariable_1 = class CompoundToolVariable extends ToolVariable {
    constructor(value) {
        super(ToolVariableType.COMPOUND);
        this.value = value;
        JSON.validate(this, ToolVariable);
    }
    getValue(parameters) {
        const allMatches = this.value.match(CompoundToolVariable_1.ALL_REGEX);
        log.debug('Compound variable parsing: ', allMatches);
        let parsedVal = this.value;
        if (allMatches) {
            for (const match of allMatches) {
                let variableName = match;
                const isQuoted = match.startsWith("'");
                if (isQuoted) {
                    variableName = variableName.substring(1, variableName.length - 1);
                }
                const { varName, paramType } = ToolParameterHelper.parseToolParameterString(variableName);
                parsedVal = parsedVal.replace(variableName, ToolParameterHelper.getToolParameter(parameters, varName, paramType).value);
            }
        }
        return parsedVal;
    }
};
// Chatgpt made this regex, don't ask Jon!
CompoundToolVariable.ALL_REGEX = /'@[\w\s.]*'|@[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)?\b/g;
CompoundToolVariable = CompoundToolVariable_1 = __decorate([
    JsonSchemaV2(compoundToolVariableSchema, compoundToolVariableSchemaValidation),
    JsonDiscriminatorProperty('type')
], CompoundToolVariable);
export { CompoundToolVariable };
//# sourceMappingURL=compoundToolVariable.js.map